import { z } from 'zod';
export const ChangeEmailSchema = z.object({
    email: z.string().email()
});
//# sourceMappingURL=changeEmailSchema.js.map